/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core'

export default function ZStack(props) {
    return (
        <div css={css`
            position: relative;
        `}>
            <div >
                {props.children[0]}
            </div>
            <div css={css`
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
            `}>
                {props.children[1]}
            </div>
        </div>
    )
}